var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-profile-collection"},[_c('CommonHeader',[_vm._v(_vm._s(_vm.$t('profile.collect.name')))]),_c('main',[_c('NavTab',{staticClass:"nav",attrs:{"nav":_vm.types}}),_c('KeepAlive',[_c('RouterView')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }